import { render } from "./AttrDebugger.vue?vue&type=template&id=dec0206e"
import script from "./AttrDebugger.vue?vue&type=script&lang=js"
export * from "./AttrDebugger.vue?vue&type=script&lang=js"

import "./AttrDebugger.vue?vue&type=style&index=0&id=dec0206e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrDebugger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dec0206e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dec0206e', __exports__)) {
    api.reload('dec0206e', __exports__)
  }
  
  module.hot.accept("./AttrDebugger.vue?vue&type=template&id=dec0206e", () => {
    api.rerender('dec0206e', render)
  })

}


export default __exports__